export const LP_URL = '/sol/contents/client/';
export const INPUT_URL = '/clcd/odform/input';
export const CONF_URL = '/clcd/odform/conf';
export const THANKS_URL = '/clcd/odform/thanks';
export const ADD_INPUT_URL = '/clcd/odform/add-input';
export const ADD_CONF_URL = '/clcd/odform/add-conf';
export const ADD_THANKS_URL = '/clcd/odform/add-thanks';
export const FIRST_URL = '/clcd/odform/input';

export const EKI_SUGGEST_PATH = '/v1/jobsearch/ekisuggest';
export const HOURSALARY_SUGGEST_PATH = '/v1/getHourSalary';
export const ADD_SEARCH_PATH = '/v1/addresses/search';
export const REGISTER_ORDER_PATH = '/v1/registerOrder';
export const REGISTER_REQUEST_PATH = '/v1/registerRequest';
export const LEAVE_WITHOUT_ORDER_PATH = '/v1/leaveWithoutOrder';
export const CHECK_EKICODE_PATH = '/v1/checkEkiCode';

export const BUTTON_NO_PREV = 'BUTTON_NO_PREV';
export const BUTTON_DEFAULT = 'BUTTON_DEFAULT';
export const BUTTON_CONF = 'BUTTON_CONF';
export const BUTTON_BACKLP = 'BUTTON_BACKLP';
export const BUTTON_NONE = 'BUTTON_NONE';
export const ROOT_ELEMENT_ID = 'root';

export const CHOICES_NAME_MAP = {
  workCategoryOtherDetail: 'その他',
  workDetailText: 'お仕事内容の詳細',
  companyNameText: '企業名',
  dept: '派遣先部課名',
  chargePersonNameText: 'ご担当者名',
  tel: '電話番号',
  email: 'メールアドレス',
  address: '派遣先住所',
  ekiName: '駅名',
  desiredStartDate: '就業開始希望日日付指定',

  overTime: '残業時間',
  _modalSalaryMin: '請求金額目安（1時間）',
  _modalWorkInfo: '仕事内容',
  _modalWorkEnvi: '職場環境',
  _modalOtherSkill: 'その他スキル',
  _modalWorkTime: '勤務時間',
  _selectWorkPeriod: '就業予定期間',
  _selectDayOfTheWeek: '勤務日',


  otherComment: 'その他連絡事項',
  workInfoContentCmnt: '上記以外',
  skillOtherCmnt: 'その他',
  bgdOfRecruitmentCmnt: 'その他',
  workStyleCmnt: 'その他',
  startTimeCmnt: '上記以外',
  endTimeCmnt: '上記以外',
  workPeriodCmnt: 'その他',

  _selectBgdOfRecruitmentCmnt: 'その他',
  _selectWelfare: '福利厚生',

  notShow: '非表示',
  require: '必須'
};

// エラーメッセージ定義
export const ERROR_MESSAGES = [
  { pattern: /^should NOT be shorter than 1 characters/, label: 'を入力してください' },
  { pattern: /^should NOT be longer than/, label: 'の入力内容が長すぎます' },
  { pattern: /^should match pattern/, label: 'の入力内容が不正です' },
  { pattern: /^should NOT have fewer than 1 items/, label: 'を選択してください' },
  { pattern: /^should NOT have more than 5 items/, label: 'は最大5つまでです' },
  { pattern: /^should match "else" schema/, label: 'の入力内容が不正です' },
];
export const CUSTOM_ERROR_MESSAGES = {
  /* 業務ロジックチェックのエラーメッセージ */
  checkEkiCodeNG: 'サービス対象外エリアです',
  ekiSuggestZero: '該当する駅が見つかりません',
  checkDesiredStartDateNG: '就業開始希望日日付指定の入力内容が不正です',
  syuugyouTimeNG: '勤務時間の入力内容が不正です',
  remoteWorkCountNG: 'テレワークの頻度を選択してください',
};
export const FATAL_ERROR = 'OLOD_FATAL_ERROR';
export const FATAL_ERROR_MESSAGES = [
  '予期せぬエラーが発生しました。',
  '申し訳ありませんが、しばらくたってから再度実行してください。',
];
export const DROPDOWN_INITIAL_ITEM = { value: '', label: '選択する' }; // labelが空だと画面が崩れる

export const CHOICES_MAP = {
  /* 項目のテキスト */
  workCategoryList: [
    { value: 'A', label: 'オフィスワーク・事務' },
    { value: 'B', label: 'ITエンジニア・WEBクリエイター・その他技術系' },
    { value: 'C', label: '営業・販売・接客' },
    { value: 'D', label: '介護' },
    { value: 'E', label: 'その他' },
  ],
  workCategorySubList: [
    { value: 'A01', label: '一般事務・OA事務・総務事務' },
    { value: 'A02', label: '営業事務（受発注）・秘書' },
    { value: 'A03', label: '経理事務' },
    { value: 'A04', label: '人事事務（給与社保・採用教育）' },
    { value: 'A05', label: '貿易事務' },
    { value: 'A99', label: 'その他' },
    { value: 'B01', label: 'システム開発(PM・SE・プログラマー)' },
    { value: 'B02', label: 'WEB(ディレクター・デザイナー・コーダー)' },
    { value: 'B03', label: 'ヘルプデスク・サポートデスク' },
    { value: 'B04', label: 'CADオペレーター' },
    { value: 'B99', label: 'その他' },
    { value: 'C01', label: '営業（訪問営業・テレアポ）' },
    { value: 'C02', label: '販売' },
    { value: 'C03', label: 'テレフォンオペレーター' },
    { value: 'C04', label: '受付・案内' },
    { value: 'C99', label: 'その他' },
  ],
  workOfficeTypeList: [
    { value: 'A01', label: '一般事務・OA事務・総務事務' },
    { value: 'A02', label: '営業事務（受発注）・秘書' },
    { value: 'A03', label: '経理事務' },
    { value: 'A04', label: '人事事務（給与社保・採用教育）' },
    { value: 'A05', label: '貿易事務' },
    { value: 'A99', label: 'その他' },
  ],
  workITTypeList: [
    { value: 'B01', label: 'システム開発(PM・SE・プログラマー)' },
    { value: 'B02', label: 'WEB(ディレクター・デザイナー・コーダー)' },
    { value: 'B03', label: 'ヘルプデスク・サポートデスク' },
    { value: 'B04', label: 'CADオペレーター' },
    { value: 'B99', label: 'その他' },
  ],
  workMarketingTypeList: [
    { value: 'C01', label: '営業（訪問営業・テレアポ）' },
    { value: 'C02', label: '販売' },
    { value: 'C03', label: 'テレフォンオペレーター' },
    { value: 'C04', label: '受付・案内' },
    { value: 'C99', label: 'その他' },
  ],

  howToDo: [
    { value: '01', label: [ '追加入力を行い', 'すぐに人選を開始する' ], subLabel: [ '(入力時間目安：3分～5分)' ], point: ['＼人材要件がお決まりの方はこちら／'] },
    { value: '02', label: [ '入力を完了し', '弊社担当からの連絡を待つ' ], subLabel: [ '(電話時間目安：20分～30分)' ] },
  ],
  workInfoContentList: [
    { value: '01', label: 'データ入力' },
    { value: '02', label: 'Excelでのデータ集計' },
    { value: '03', label: 'Excelでの資料作成' },
    { value: '04', label: 'PowerPointでの資料作成' },
    { value: '05', label: '電話・来客応対' },
    { value: '06', label: 'ファイリング' },
    { value: '07', label: '備品管理' },
    { value: '08', label: '郵便物対応' },
    { value: '09', label: 'スケジュール調整・連絡 ' },
    { value: '10', label: '上記以外' },
  ],
  dayOfTheWeekList: [
    { value: '1', label: '月' },
    { value: '2', label: '火' },
    { value: '3', label: '水' },
    { value: '4', label: '木' },
    { value: '5', label: '金' },
    { value: '6', label: '土' },
    { value: '0', label: '日' },  
  ],
  skillLevelList: [
    { value: '01', label: '初級' },
    { value: '02', label: '中級' },
    { value: '03', label: '上級' },
  ],
  skillLevelExcelList: [
    { value: '01', label: 'フォーマットへの入力・修正 ・保存' },
    { value: '02', label: '四則演算、SUM・AVERAGE 関数などの利用、グラフ・表の作成' },
    { value: '03', label: 'IF関数やVLOOKUP関数、ピボットテーブルなどの利用' },
  ],
  skillLevelPowerpointList: [
    { value: '01', label: '既存資料への入力・修正' },
    { value: '02', label: '資料の新規作成' },
    { value: '03', label: '描画機能の利用' },
  ],
  skillLevelExcelConfList: [
    { value: '01', label: '初級（フォーマットへの入力・修正 ・保存）' },
    { value: '02', label: '中級（四則演算、SUM・AVERAGE 関数などの利用、グラフ・表の作成）' },
    { value: '03', label: '上級（IF関数やVLOOKUP関数、ピ ボットテーブルなどの利用）' },
  ],
  skillLevelPowerpointConfList: [
    { value: '01', label: '初級（既存資料への入力・修正）' },
    { value: '02', label: '中級（資料の新規作成）' },
    { value: '03', label: '上級（描画機能の利用）' },
  ],
  skillOtherList: [
    { value: '01', label: '' },
  ],
  bgdOfRecruitmentList: [
    { value: '01', label: '社員の代替' },
    { value: '02', label: '派遣社員の代替' },
    { value: '03', label: '増員' },
    { value: '04', label: '繁忙期対応（期間限定）' },
    { value: '05', label: 'その他' },
  ],
  workEnviList: [
    { value: '01', label: '駅5分以内' },
    { value: '02', label: '近くにコンビニやカフェあり' },
    { value: '03', label: '大手企業' },
    { value: '04', label: '外資系' },
    { value: '05', label: '服装自由' },
    { value: '06', label: '制服有り' },
    { value: '07', label: 'オフィスカジュアル' },
    { value: '08', label: '研修制度あり' },
    { value: '09', label: '車通勤可' },
    { value: '10', label: '活気ある職場' },
    { value: '11', label: '静かな職場' },
    { value: '12', label: 'アットホーム' },
    { value: '13', label: '広々としたオフィス' },
  ],
  workStyleList: [
    { value: '01', label: '平日週5勤務' },
    { value: '02', label: 'その他(シフト勤務など)' },
  ],
  startTimeList: [
    { value: '01', label: '09:00' },
    { value: '02', label: '09:30' },
    { value: '03', label: '10:00' },
    { value: '04', label: '10:30' },
    { value: '05', label: '上記以外' },
  ],
  endTimeList: [
    { value: '01', label: '17:00' },
    { value: '02', label: '17:30' },
    { value: '03', label: '18:00' },
    { value: '04', label: '18:30' },
    { value: '05', label: '上記以外' },
  ],
  overTimeList: [
    { value: '01', label: '残業なし' },
    { value: '02', label: '20時間/月 以下' },
    { value: '03', label: '21時間/月 以上' },
  ],
  desiredStartDateKubunList: [
    { value: '01', label: '即日開始' },
    { value: '02', label: '日付指定' },
  ],
  workPeriodList: [
    { value: '03', label: '短期（３ヶ月未満）' },
    { value: '02', label: '長期（終了時期未定）' },
    { value: '01', label: 'その他（期間限定など）' },
  ],
  
  hourList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
  ],
  minuteList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '00', label: '00' },
    { value: '05', label: '05' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' },
    { value: '35', label: '35' },
    { value: '40', label: '40' },
    { value: '45', label: '45' },
    { value: '50', label: '50' },
    { value: '55', label: '55' },
  ],
  restTimeList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '15', label: '15' },
    { value: '30', label: '30' },
    { value: '45', label: '45' },
    { value: '60', label: '60' },
    { value: '75', label: '75' },
    { value: '90', label: '90' },
    { value: '105', label: '105' },
    { value: '120', label: '120' },
  ],
  overTimeHourList: [
    DROPDOWN_INITIAL_ITEM,
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
    { value: '24', label: '24' },
    { value: '25', label: '25' },
    { value: '26', label: '26' },
    { value: '27', label: '27' },
    { value: '28', label: '28' },
    { value: '29', label: '29' },
    { value: '30', label: '30' },
    { value: '31', label: '31' },
    { value: '32', label: '32' },
    { value: '33', label: '33' },
    { value: '34', label: '34' },
    { value: '35', label: '35' },
    { value: '36', label: '36' },
    { value: '37', label: '37' },
    { value: '38', label: '38' },
    { value: '39', label: '39' },
    { value: '40', label: '40' },
    { value: '41', label: '41' },
    { value: '42', label: '42' },
    { value: '43', label: '43' },
    { value: '44', label: '44' },
    { value: '45', label: '45' },
  ],
  remoteWorkList: [
    { value: '01', label: '可' },
    { value: '02', label: '不可' },
  ],
  remoteWorkCountList: [
    { value: '01', label: '週に1～2日' },
    { value: '02', label: '週に3～4日' },
    { value: '03', label: 'すべてテレワーク' },
  ],
  holidayWorkList: [
    { value: '01', label: '発生しない' },
    { value: '02', label: '発生する' },
  ],
  timeSavingAvaList: [
    { value: '01', label: '可能' },
    { value: '02', label: '不可' },
  ],
  useCarList: [
    { value: '01', label: '発生しない' },
    { value: '02', label: '発生する' },
  ],
  smokeEnviList: [
    { value: '01', label: '禁煙' },
    { value: '02', label: '喫煙ルーム利用可' },
  ],
  welfareList: [
    { value: '01', label: '食堂利用可' },
    { value: '02', label: '休憩室利用可' },
    { value: '03', label: '更衣室利用可' },
    { value: '04', label: '医療施設利用可' },
    { value: '09', label: '該当なし' },    
  ],
  floatingBanner : [
    { value: '01', label: '勤務条件を入力する' },
    { value: '02', label: '職場情報を入力する' },
  ],
};

export const PAGE_MAP = {
  [INPUT_URL]: {
    step: '1',
    subStep: null,
    url: INPUT_URL,
    nextUrl: CONF_URL,
    prevUrl: null,
    buttonType: BUTTON_NO_PREV,
    title: '派遣依頼ご相談フォーム',
  },
  [CONF_URL]: {
    step: '2',
    subStep: null,
    url: CONF_URL,
    nextUrl: THANKS_URL,
    nextOdUrl: ADD_INPUT_URL,
    prevUrl: INPUT_URL,
    buttonType: BUTTON_DEFAULT,
    title: '派遣依頼ご相談フォーム　入力内容の確認',
  },
  [THANKS_URL]: {
    step: '3',
    subStep: null,
    url: THANKS_URL,
    nextUrl: LP_URL,
    prevUrl: CONF_URL,
    buttonType: BUTTON_BACKLP, 
    title: [ 'ご依頼を受け付けました。', '担当よりご連絡いたします。' ],
  },
  [ADD_INPUT_URL]: {
    step: '3',
    subStep: null,
    url: ADD_INPUT_URL,
    nextUrl: ADD_CONF_URL,
    prevUrl: CONF_URL,
    buttonType: BUTTON_NONE,
    title: '',
  },
  [ADD_CONF_URL]: {
    step: '4',
    subStep: null,
    url: ADD_CONF_URL,
    nextUrl: ADD_THANKS_URL,
    prevUrl: ADD_INPUT_URL,
    buttonType: BUTTON_CONF,
    title: '依頼内容の確認',
  },
  [ADD_THANKS_URL]: {
    step: '5',
    subStep: null,
    url: ADD_THANKS_URL,
    nextUrl: LP_URL,
    prevUrl: ADD_CONF_URL,
    buttonType: BUTTON_BACKLP,
    title: [ 'ご依頼いただいた内容で人選を開始します。', '担当よりご連絡いたしますのでお待ちください。' ],
  },
  default: {
    step: '---',
    subStep: null,
    url: '/',
    nextUrl: '/',
    prevUrl: null,
    buttonType: BUTTON_DEFAULT,
    title: 'タイトル',
  },
};

export const MEASURE_MAP = {
  EVENT_EKI_SELECT: {
    name: '駅選択',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,prop37,eVar37,prop54,eVar54',
    eVar37: 'D=c37',
  },
  EVENT_82: {
    name: 'オンライン発注フォーム_入力ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event82',
    events: 'event82', 
  },
  EVENT_83: {
    name: '派遣依頼_発注完了ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event83',
    events: 'event83', 
  },
  EVENT_84: {
    name: '派遣依頼確認画面_次へボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event84',
    events: 'event84', 
  },
  EVENT_85: {
    name: 'オンライン発注確認画面_送信ボタン',
    linkTrackVars: 'eVar1,prop3,prop4,eVar4,prop5,eVar5,prop31,eVar31,events',
    linkTrackEvents: 'event85',
    events: 'event85', 
  },
};

// debug, storybook用のダミーパラメータ
export const debugInitialState = {
  /* Input */
  workCategory: 'A',
  workCategorySub: [ ],
  workCategoryOtherDetail: '',
  workDetailText: '詳細が入る',
  employmentPlacementDispatching: false,
  companyNameText: '企業',
  dept: '派遣先部課名',
  chargePersonNameText: 'なまえ',
  tel: '09011112222',
  email: 'test@r-staffing.co.jp',
  address: '東京都中央区',
  ekiCd: '22828',
  ekiName: '東京',
  receiptID: '',

  /* Add-Input, Add-Conf */
  desiredStartDateKubun: '01',
  desiredStartDate: '',
  dayOfTheWeek: [ ],
  hourSalaryMin: '2600',
  hourSalaryMax: '3200',
  timeSavingAva: '01',
  overtimeHoursMin: '',
  overtimeHoursMax: '',
  workInfo: [ '01', '02', '03', '04', '05', '06', '07', '08' ],
  workInfoContent: [],
  strWorkInfo: '',
  skillLevel: '01',
  suggestHourSalary: '',
  skillLevelExcel: '',
  skillLevelPowerpoint: '',
  bgdOfRecruitment: '01',
  workEnvi: [ '01', '02', '03', '04', '05', '06', '07' ],
  strWorkEnvi: '',
  strOtherSkill: '',
  strWorkPeriod: '',
  strDayOfTheWeek: '',
  workStyle: '01',
  startTime: '01',
  endTime: '01',
  overTime: '01',
  workPeriod: '01',
  otherComment: '',
  remoteWork: '01',
  remoteWorkCount: '02',
  holidayWork: '01',
  useCar: '01',
  smokeEnvi: '01',
  welfare: ['01','02'],

  isModify: false,
  validMap: {
    [INPUT_URL]: true,
    [CONF_URL]: true,
    [THANKS_URL]: true,
    [ADD_INPUT_URL]: true,
    [ADD_CONF_URL]: true,
    [ADD_THANKS_URL]: true,
  },
  isRegistered: false,
  isAddRegistered: false,
  isRegisteredLeaveWithoutOrder: false,
  hourSalaryLoading: true,

  clickID: 'clickID12345',
  mediaID: 'mediaID12345',
};

export const MOVE_CONF_MSG = '他のページに移動しますか？入力したデータは保存されません。';

export const THANKS_TEXT = {
  information: '依頼内容の修正や確認事項がございましたら、下記までご連絡ください。',
};

export const ADD_THANKS_TEXT = {
  information: '依頼内容の修正や確認事項がございましたら、下記までご連絡ください。',
};

export const ADD_CONF_OD_TITLE_TEXT = {
  workDetail: '勤務条件',
  desiredStartDate: '就業開始日',
  workPeriod: '就業予定期間',
  workDay: '勤務日',
  workTime: '勤務時間',
  overTime: '残業時間',
  salary: '請求金額目安',
  jobDescription: '職務内容',
  jobList: '仕事内容',
  software: 'ソフト・ツール',
  otherSkill: 'その他スキル',
  jobInfo: '職場情報',
  workEnvi: '職場環境の特徴',
  bgdOfRecruitment: '募集背景',
  buttonChange: 'この内容で変更する',
  otherComment: 'その他連絡事項',
  remoteWork: 'テレワーク',
  holidayWork: '休日出勤',
  timeSavingAva: '時短制度',
  useCar: '車利用',
  smokeEnvi: '喫煙',
  welfare: '福利厚生',
};

export const ADD_INPUT_CONF_TITLE = {
  workEnvi: '職場環境を教えてください（複数選択可）',
  remoteWork: '派遣スタッフのテレワークは可能ですか？',
  remoteWorkCount: 'テレワークの頻度を選択してください',
  holidayWork: '休日出勤は発生しますか？',
  timeSavingAva: '時短制度利用可能ですか？',
  smokeEnvi: '喫煙環境で該当するものを選択ください',
  useCar: '車を使った業務は発生しますか？',
  welfare: '福利厚生で該当するものを選択ください',
};

export const COMMENT_MAP = {
  // 業務内容
  workInfoContentCmnt: {
    value: '10', // 連動する親項目の値を設定する
    title: '上記以外の業務内容や補足がある場合は入力してください。',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '総務のアシスタント業務',
      '・備品の発注',
      '・電話対応',
      '・郵便物の発送、配布',
      '・精算書の確認、入力',
      '・その他付随する庶務業務',
      '',
      '立ち位置：社員6名+今回ポジション',
      '仕事の特徴：定型業務7割 + 非定型業務3割',
    ],
  },
  // その他スキル
  skillOtherCmnt: {
    value: '',
    title: 'その他、ご希望のスキルや経験について、必要な場面や理由を含めて教えてください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '3ヵ月は既存フォーマットへのデータ入力、修正を行い、その後はSUM関数を使った集計作業を依頼予定。事務経験が1年以上あり、下記のようなスキルの方を求めます。',
      '【必須】SUM関数を使用できる方',
      '【可能であれば】SUMIFやCOUNTIF関数を使用できる方。',
    ],
  },
  // 募集背景
  bgdOfRecruitmentCmnt: {
    value: '05',
    title: 'その他の場合は募集背景について記入してください',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: '',
  },
  // 勤務形態
  workStyleCmnt: {
    value: '02',
    title: '平日週5勤務以外の場合は、こちらに勤務日数、曜日、条件を入力してください。',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '・週5日、必ず勤務する曜日：月、木、金、土、勤務可能性のある曜日：月、火、水、木、金、土',
      '※火曜日、水曜日も出勤の場合があり、日曜日+シフトで1日休みの週休2日制です。',
      '',
      '・シフト制で週3～4日で選べます。',
      '必ず勤務する曜日：月',
      '勤務可能性のある曜日：月、火、水、木、金',
    ],
  },
  // 始業時間
  startTimeCmnt: {
    value: '05',
    title: '上記以外の時間やその他補足事項がある場合は記入してください。',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '・全ての曜日で11:00始業',
    ],
  },
  // 終業時間
  endTimeCmnt: {
    value: '05',
    title: '上記以外の時間やその他補足事項がある場合は記入してください。',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '・基本16:00終業（金曜のみ18:00終業）',
    ],
  },
  // 勤務時間
  workTimeCmnt: {
    value: '',
    title: '',
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '9:00～17:00 （うち休憩時間60分）',
      '金曜のみ18:00就業',
    ],
  },

  // 就業予定期間
  workPeriodCmnt: {
    value: '01',
    title: [
      '期間限定の場合はいつまでの期間限定かを入力してください。',
      'また、補足事項がある場合は入力してください。',
    ],
    subTitle: '',
    popUpTitle: '',
    popUpDetail: [
      '例）',
      '・〇年〇月〇日までの期間限定',
      '・〇年〇月〇日から半年間の期間限定を想定',
    ],
  },
};

export const PMARK = {
  DEV: 'https://www-dev100.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
  STG: 'https://www-stg.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
  MAIN: 'https://www.r-staffing.co.jp/sol/contents/img/footer/footer_privacy.png',
};